<template>
  <el-dialog
    :visible.sync="visible"
    :title="!dataForm.id ? $t('add') : $t('update')"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      @keyup.enter.native="dataFormSubmitHandle()"
      :label-width="$i18n.locale === 'en-US' ? '120px' : '120px'"
    >
      <div class="line-box">
        <el-form-item label="账户" prop="advertiserId">
          <el-select
            v-model="dataForm.advertiserId"
          
            filterable
            clearable
            placeholder="请选择账户"
          >
            <el-option
              v-for="item in advertisers"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!--        <el-form-item label="账户名称" prop="advertiserName">-->
        <!--            <el-input v-model="dataForm.advertiserName" placeholder="账户名称"></el-input>-->
        <!--        </el-form-item>-->
        <el-form-item label="贷款标识" prop="loanType">
          <el-select
            v-model="dataForm.loanType"
            filterable
            placeholder="请选择贷款标识"
          >
            <el-option
              v-for="item in loanTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="落地页标识" prop="standard">
          <el-select
            v-model="dataForm.standard"
            filterable
            placeholder="请选择运营方式"
            @change="standardChange"
          >
            <el-option
              v-for="item in standardList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="渠道" prop="channelId">
          <el-select
            v-model="dataForm.channelId"
            filterable
            clearable
            placeholder="请选择渠道"
          >
            <el-option
              v-for="item in channels"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运营机构" prop="operationId">
          <el-select
            v-model="dataForm.operationId"
            filterable
            clearable
            placeholder="请选择运营机构"
          >
            <el-option
              v-for="item in operations"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否直投" prop="isFixed">
          <el-select
            v-model="dataForm.isFixed"
            filterable
            clearable
            placeholder="请选择是否直投"
          >
            <el-option
              v-for="item in isFixedList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开发形式" prop="characteristic">
          <el-select
            class="hundred"
            v-model="dataForm.characteristic"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in characteristicList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <!-- <el-form-item label="腾讯/百度落地页" prop="logo">
          <el-input v-model="dataForm.logo" placeholder="腾讯/百度落地页"></el-input>
      </el-form-item> -->
        <el-form-item class="hundred" label="投放城市" prop="address">
          <el-select
            class="hundred"
            v-model="dataForm.address"
            filterable
            clearable
            multiple
            placeholder="请选择城市"
          >
            <el-option
              v-for="item in citys"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="dataForm.characteristic == '媒体自建站'"
          label="页面ID"
          prop="pageId"
        >
          <el-input
            v-model="dataForm.pageId"
            placeholder="请输入页面ID"
          ></el-input>
        </el-form-item>

        <el-form-item class="hundred" label="所属公司" prop="companyIds">
          <el-select
            class="hundred"
            v-model="dataForm.companyIds"
            filterable
            multiple
            placeholder="请选择公司"
          >
            <el-option
              v-for="item in cCompanys"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <el-form-item label=" 落地页名称" prop="name">
        <el-input v-model="dataForm.name" placeholder="落地页名称"></el-input>
      </el-form-item>
      <el-form-item label="" prop="url">
        <template slot="label">
          <!-- <el-tooltip class="item" effect="dark" content="" placement="top-start"> -->
          <span> 页面地址 </span>
          <!-- </el-tooltip> -->
        </template>
        <el-input v-model="dataForm.url" placeholder="页面地址"></el-input>
      </el-form-item>

      <el-form-item label="备注" prop="remark">
        <el-input
          type="textarea"
          v-model="dataForm.remark"
          placeholder="备注"
        ></el-input>
      </el-form-item>
      <!--          <el-form-item label="状态（开1、关0）" prop="status">-->
      <!--          <el-input v-model="dataForm.status" placeholder="状态（开1、关0）"></el-input>-->
      <!--      </el-form-item>-->
  
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t("cancel") }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
        $t("confirm")
      }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from "lodash/debounce";
export default {
  data() {
    var validateIsFixed = (rule, value, callback) => {
      if (this.dataForm.isFixed == 1 && value.length > 1) {
        callback(new Error("直投只能选择一家"));
      } else {
        callback();
      }
    };
    return {
      visible: false,
      companys: [],
      operations: [],
      channels: [],
      advertisers: [],
      loanTypes: [],
      citys: [],
      characteristicList: [
        {
          value: "自研",
          label: "自研",
        },
        {
          value: "媒体自建站",
          label: "媒体自建站",
        },
      ],
      isFixedList: [
        {
          value: 0,
          label: "非直投",
        },
        {
          value: 1,
          label: "直投",
        },
      ],
      standardList: [
        {
          value: 0,
          label: "非标准化",
        },
        {
          value: 1,
          label: "标准化",
        },
      ],
      dataForm: {
        id: "",
        advertiserId: "",
        dvertiserName: "",
        loanType: "",
        name: "",
        url: "",
        standard: '',
                channelId: "",
        operationId: "",
        companyIds: [],
        remark: "",
        status: "",
        createBy: "",
        createTime: "",
        updateBy: "",
        updateTime: "",
        deleteTime: "",
        isFixed: "",
        characteristic: "",
        pageId: "",
        address: [],
      },
      dataRule: {
        isFixed: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        pageId: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        standard: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        repeatFlag: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        advertiserId: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        loanType: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        url: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        channelId: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        operationId: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        companyIds: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "change",
          },
          { validator: validateIsFixed, trigger: "change" },
        ],
        // remark: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        characteristic: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        status: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        createBy: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        createTime: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        updateBy: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        updateTime: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        deleteTime: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    cCompanys(){
      return  this.companys.filter(item => item.standard == this.dataForm.standard)
    }
  },
  methods: {
    init() {
      this.getCompanysOptions();
      this.getOperatorsOptions();
      this.getchannelsOptions();
      this.getAdvertisersOptions();
      this.getLoanTypeOptions();
      this.getCityOptions();
      this.visible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
        if (this.dataForm.id) {
          this.getInfo();
        }
      });
    },
    standardChange(){
      this.dataForm.companyIds = []
    },
    // 获取信息
    getInfo() {
      this.$http
        .get(`/sys/landingpages/${this.dataForm.id}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          console.log(1);
          // res.data.address = res.data?.address.split('|')
          if (res.data.address) {
            res.data.address = res.data?.address.split("|");
          } else {
            res.data.address = [];
          }

          this.dataForm = {
            ...this.dataForm,
            ...res.data,
          };
          console.log(res.data);
          // this.dataForm.address = res.data?.address.split('|')
          // console.log( this.dataForm.address)
        })
        .catch(() => {});
    },
    //初始化公司下拉框中的选项
    async getCompanysOptions() {
      this.$http
        .get(`/sys/companies/list`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.companys = [];
          if (res.data != null) {
            res.data.forEach((element) => {
              this.companys.push({ label: element.name, value: element.id ,standard: element.standard});
            });
          }
        })
        .catch(() => {});
    },
    //初始化贷款标识下拉框中的选项
    async getLoanTypeOptions() {
      this.$http
        .get(`/sys/dict/data/list?dataType=loan_type`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.loanTypes = [];
          if (res.data != null) {
            res.data.forEach((element) => {
              this.loanTypes.push({
                label: element.dictLabel,
                value: element.dictValue,
              });
            });
          }
        })
        .catch(() => {});
    },
    //初始化渠道下拉框中的选项
    async getchannelsOptions() {
      this.$http
        .get(`/sys/channels/list`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.channels = [];
          if (res.data != null) {
            res.data.forEach((element) => {
              this.channels.push({ label: element.name, value: element.id });
            });
          }
        })
        .catch(() => {});
    },
    //初始化下拉框中的选项
    async getCityOptions() {
      this.$http
        .get(`/sys/dict/data/list?dataType=landing_page_city`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.citys = [];
          if (res.data != null) {
            res.data.forEach((element) => {
              this.citys.push({
                label: element.dictLabel,
                value: element.dictValue,
              });
            });
            /*let citys = {}
                  for(let i = 0; i< res.data.length; i++){
                      citys[i].value=res.data[i].dictValue
                      citys[i].label=res.data[i].dictLabel
                  }*/
          }
        })
        .catch(() => {});
    },
    //初始化公司下拉框中的选项
    async getOperatorsOptions() {
      this.$http
        .get(`/sys/operations/list`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.operations = [];
          if (res.data != null) {
            res.data.forEach((element) => {
              this.operations.push({ label: element.name, value: element.id });
            });
          }
        })
        .catch(() => {});
    },
    //初始化广告主账户下拉框中的选项
    async getAdvertisersOptions() {
      this.$http
        .get(`/sys/rdadvertiser/list`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.advertisers = [];
          if (res.data != null) {
            res.data.forEach((element) => {
              this.advertisers.push({
                label: element.advertiserName,
                value: element.advertiserId,
              });
            });
          }
        })
        .catch(() => {});
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function () {
        this.$refs["dataForm"].validate((valid) => {
          if (!valid) {
            return false;
          }
          this.$unblank(this.dataForm);
          let address = ''
          if (this.dataForm.address) {
            address = this.dataForm.address.join("|");
          }

          this.$http[!this.dataForm.id ? "post" : "put"](
            "/sys/landingpages/",
            {...this.dataForm,address: address}
           
          )
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return this.$message.error(res.msg);
              }
              this.$message({
                message: this.$t("prompt.success"),
                type: "success",
                duration: 500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                },
              });
            })
            .catch(() => {});
        });
      },
      1000,
      { leading: true, trailing: false }
    ),
  },
};
</script>
<style scoped lang="scss">
.line-box {
  display: flex;
  flex-wrap: wrap;
}
</style>